<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<!-- <h4 class="card-title"></h4>
					<p class="card-title-desc"></p> -->

						<!----- top button area starts---->
						<div class="row mb-3">
							<div class="col-12">
								<b-button v-b-modal.test-modal variant="primary" class="btn btn-primary float-end">Add
									Test</b-button>
							</div>
						</div>
						<!----- top button area ends---->

						<!----- Listing length and search starts ----->
						<div class="row mb-3">
							<div class="col-sm-12 col-md-6">
								<div class="listing-length">
									<label>Show
										<select class="form-control" v-model="limit" @change="fetchTest()">
											<option value="5">5</option>
											<option value="10">10</option>
											<option value="15">15</option>
										</select>
										entries
									</label>
								</div>
							</div>
							<div class="col-sm-12 col-md-6">
								<div class="listing-filter">
									<label>
										<input type="text" class="form-control" v-model="keyword" placeholder="Search"
											@keyup="fetchTest()" />
									</label>
								</div>
								<div class="listing-filter me-2">
									<label>
										<select class="form-control" v-model="status" @change="fetchTest()">
											<option value="">All</option>
											<option value="1">Published</option>
											<option value="2">Unpublished</option>
										</select>
									</label>
								</div>
							</div>
						</div>
						<!----- Listing length and search ends ----->

						<!---- listing table starts -------->
						<div class="table-responsive">
							<table class="table table-bordered mb-0">

								<thead class="table-light">
									<tr>
										<th>Name</th>
										<th>Description</th>
										<th>Price</th>
										<th>Type</th>
										<th>Status</th>
										<th>Options</th>
									</tr>
								</thead>
								<tbody v-if="Boolean(assigned_tests.length)">
									<tr v-for="(assigned_test) in assigned_tests" :key="assigned_test.id">
										<td style="max-width: 300px; word-wrap: break-word;"> {{ assigned_test.name }}</td>
										<td style="max-width: 300px; word-wrap: break-word;"> {{ assigned_test.description }}</td>
										<td>Rs.{{ assigned_test.price }}</td>
										<td><span v-if="assigned_test.type === 1">Lab</span>
										<span v-else-if="assigned_test.type === 2">Home</span>
										<span v-else-if="assigned_test.type === 3">Both</span>
										</td>
										<td>{{ assigned_test.status === 1 ? 'Active' : 'Blocked' }}</td>
										<td>

											<!-- <b-button variant="primary" class="btn btn-sm mt-2 me-1" @click="editTest()">Edit</b-button> -->
											<b-button v-if="assigned_test.status === 1" variant="danger" @click="testUnpublish(assigned_test)" class="btn mt-2 me-1 btn-sm">Unpublish</b-button>
											<b-button v-if="assigned_test.status === 2" variant="success" @click="testPublish(assigned_test)" class="btn mt-2 me-1 btn-sm">publish</b-button>
											<b-button variant="primary" @click="editTestModal(assigned_test)"
												class="btn mt-2 me-1 btn-sm">Update</b-button>

										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr>
										<td colspan="5" class="text-center">No tests found</td>
									</tr>
								</tbody>

							</table>
						</div>
						<!---- listing table ends -------->

						<!----pagination starts --->
						<caption v-if="Boolean(assigned_tests.length)" class="float-start mt-4 d-block d-lg-inline">Showing
							{{ this.from }} to {{ this.to }} of {{ this.total }} entries</caption>
						<ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
							<li class="page-item " v-bind:class="[{ disabled: !page.url }, { active: page.active }]"
								v-for="(page, index) in pagination" :key="page.label">
								<a href="#" class="page-link"
									@click.prevent="fetchTest(page.url + '&limit=' + limit + '&search=' + keyword + '&status=' + status)">
									<i v-if="index == 0" class="mdi mdi-chevron-left"></i>
									<i v-else-if="index == pagination.length - 1" class="mdi mdi-chevron-right"></i>
									<span v-else>{{ page.label }}</span>
								</a>
							</li>
						</ul>
						<!----pagination ends --->

					</div>
				</div>
			</div>

  				<b-modal ref="test-modal" id="test-modal" :title="modal_title" hide-footer @hidden="clearForm()">
                     <b-form @submit.prevent = "assignTest">
                        <div class="row">
                                    <div class="form-group col-12"> 
                                       <label class="control-label">Test Name <span class="text-danger">*</span></label>
                                       <select class="form-control" @change="addTest()" v-model="selectedTest" v-bind:class="{ 'is-invalid': Boolean(errors.test_ids && errors.test_ids.length > 0) }">
                                          <option value="" >Select</option>
                                          <option :value="all_test.id" v-for="all_test in all_tests" :key="all_test.id">
                                          {{ all_test.name }}</option>
                                       </select>
                                       <div v-for="(val, index) in errors.test_ids" :key="index" class="invalid-feedback">
                                          <p class="mb-0">{{ val }}</p>
                                       </div>

                                    </div>

                                    <div class="col-12">
                                       <div class="input-tag" v-for="(test, index) in tests" :key="index">
                                             <p>{{ test.title }}<span @click="removeTest(index)" class="text-danger"  v-bind:class="{ 'is-invalid': Boolean(errors.test_ids) }"><i class="fas fa-times-circle"></i></span></p>
                                             <div v-for="(val, index) in errors.test_ids" :key="index" class="invalid-feedback">
                                                <p class="mb-0">{{ val }}</p>
                                             </div>
                                       </div>
                                    
                                    </div>

                                 </div>
                       
                        <b-col md="12">
                           <b-button type="submit" class="me-3" variant="primary" :disabled="submit_loading">
                             <span v-if="submit_loading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                             {{ button_title }}
                           </b-button>
                           <b-button class="" variant="light" @click="hideModal('test-modal')">Close</b-button>
                        </b-col>
                     </b-form>
                  </b-modal>
			<b-modal ref="test-modal2" id="test-modal2" :title="modal_title" hide-footer @hidden="clearForm()">
				
				<b-form @submit.prevent="editTest()" v-if="isEdit">

					<b-col md="12" class="form-group">
						
						<label class="control-label">Price <span class="text-danger">*</span></label>
						<b-input-group>
                              <b-input-group-prepend>
                                 <b-input-group-text>Rs</b-input-group-text>
                              </b-input-group-prepend>
						<b-form-input v-model="edit_test.prize" @keypress="numbersOnly" 
							v-bind:class="{ 'is-invalid': Boolean(errors.price) }"></b-form-input>
						<div v-for="(val, index) in errors.price" :key="index" class="invalid-feedback">
							<p class="mb-0">{{ val }}</p>
						</div> 
					</b-input-group>
					</b-col>
					<b-col md="12" class="form-group">
						<label>Test Type</label>
						<select class="form-control" v-model="edit_test.test_type" v-bind:class="{ 'is-invalid': Boolean(errors.type) }">
							<option value="" selected>Select Type</option>
							<option value="1">Lab</option>
							<option value="2">Home</option>
							<option value="3">Both</option>
						</select>
						<div v-for="(val, index) in errors.type" :key="index" class="invalid-feedback">
								<p class="mb-0">{{ val }}</p>
						</div>
					</b-col>
					<b-col md="12">
						<b-button type="submit" class="me-3" variant="primary" :disabled="submit_loading">
						  <span v-if="submit_loading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
						  {{ button_title }}
						</b-button>
						<b-button class="" variant="light" @click="hideModal('test-modal2')">Close</b-button>
					</b-col>
				</b-form>
			</b-modal>

		</div>
	</Layout>
</template>

<script>
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import appConfig from "@/app.config";


export default {
	page: {
		title: "Tests",
		meta: [
			{
				name: "description",
				content: appConfig.description,
			},
		],
	},
	components: { Layout, PageHeader },


	data() {
		return {
			title: "Tests",
			items: [
				{
					text: "View Tests",
					active: true,
				},
			],

			loading: false,
			submit_loading: false,
			pagination: {},
			isEdit: false,
			from: null,
			to: null,
			total: null,

			
			lab_tests: [],
			assigned_tests: [],
			status: '',
			keyword: '',
			showsearch: false,
			limit: 10,
			type: 0,
			token: "",
			errors: {},
			activate: false,
			deactivate: false,
			tests: [],
			test: "",
			modal_title: "Add Test",
			button_title: "Save",
            selectedTest: "",
 			all_tests: [],
			lab_id: "",

		

			active_page_url: null,
		};
	},
	mounted() {

	},

	created() {

		this.fetchTest();

	},

	methods: {

		addTest1() {
			this.getToken();

			const config = {
			headers: {

				"Accept": "application/json",
				"Authorization": "Bearer " + this.token,
			},
			};

			let url = "lab/test";
			let formData = new FormData();
         	formData.append("id", this.test);
	
			this.$axios
			.post(url, formData, config)
            .then((response) => {
               if (response.data.status) {
                  this.$swal("", response.data.message, "success");
               } else {
                  this.$swal("", response.data.message, "error");
               }
			   this.fetchTest();
			
		
				this.test = '';
				this.hideModal('test-modal');
            })
            .catch((error) => {
               if (error.response) {
                  if (error.response.data.message) {
                     this.errors = error.response.data.message;
                     //console.log(this.errors);
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            })
            .finally(() => (this.loading = false));
			
		},
		removeTest1(index) {
			this.tests.splice(index, 1);
		},
		  addTest() {
            if (this.selectedTest !== '') {
            let text = this.all_tests.find((test) => test.id === this.selectedTest).name;

            // Check if the test with the same id already exists in the 'tests' array.
            let exists = this.tests.some((test) => test.id === this.selectedTest);

            if (!exists) {
               this.tests.push({ id: this.selectedTest, title: text });
            }
            }

            // Reset the selectedTest value
            this.selectedTest = '';
         },
          removeTest(index) {
              this.tests.splice(index, 1);
          }, 

		showModal(modal) {
			this.$refs[modal].show();
		},

		hideModal(modal) {
			this.$refs[modal].hide();
		},

		getToken() {
			if (localStorage.getItem('medicino_lab')) {
				var medicino_lab = JSON.parse(localStorage.getItem('medicino_lab'));
				if (medicino_lab.token) {
					this.token = medicino_lab.token;
					this.lab_id = medicino_lab.user_id;
					
				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}

			} else {
				this.$swal("", "Session expired, please login again", "error");
				this.$router.push({ name: "login" });
			}
		},

		fetchTest(page_url = null) {

			this.getToken();

			let url = "lab/test/details?limit=" + this.limit + "&status=" + this.status + "&search=" + this.keyword;
			page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

         	this.active_page_url = page_url;
			 this.$axios
            .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
					var responseData = res.data.data;
					console.log(responseData);
					this.all_tests = responseData.all_tests;
					if(responseData.assigned_tests){
					this.from = responseData.assigned_tests.from;
					this.to = responseData.assigned_tests.to;
					this.total = responseData.assigned_tests.total;
					this.pagination = responseData.assigned_tests.links;
					this.assigned_tests = responseData.assigned_tests.data;
					}


				})
				.catch((error) => {

					if (error.response) {
						if (error.response.data.message) {

							if (typeof error.response.data.message === 'object') {
								console.log(error.response.status);
							} else {
								this.$swal("", error.response.data.message, "error");
							}
						}
						else {
							this.$swal("", "Something went wrong", "error");
						}
					} else {
						this.$swal("", "Something went wrong", "error");
					}

				})
				.finally(() => (this.loading = false));

		},
		numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         }, 

		  assignTest(){

            this.submit_loading = true;
            this.getToken();

            const config = {
               headers: {

                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/lab/test/assign";
            let formData = new FormData();
            formData.append("lab_id", this.lab_id);
            this.tests.forEach((test) => {
                  formData.append("test_ids[]", test.id);
            });
            this.$axios
               .post(url, formData, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                      this.fetchTest();
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
			   	this.fetchTest();

                  this.clearForm();
                  this.hideModal('test-modal');
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.submit_loading = false));

   

         },




		editTestModal(assigned_test) {
			this.isEdit =  true;
			this.modal_title = "Edit Test";
			this.button_title = "Update";
			this.edit_test = assigned_test;

			if (!this.edit_test.price) {
			this.edit_test.prize = '';
			} else {
			this.edit_test.prize = this.edit_test.price;
			}

			if (this.edit_test.type) {
			this.edit_test.test_type = this.edit_test.type;
			} else {
			this.edit_test.test_type = '';
			}
			
			this.showModal("test-modal2");

		},

		editTest(){
			this.submit_loading = true;
			this.getToken();

			const config = {
			headers: {

				"Accept": "application/json",
				"Authorization": "Bearer " + this.token,
			},
			};

			let url = "lab/test/update";
			let formData = new FormData();
         	formData.append("id", this.edit_test.id);
			formData.append("price", this.edit_test.prize);
			formData.append("type", this.edit_test.test_type);
	
			this.$axios
			.post(url, formData, config)
            .then((response) => {
               if (response.data.status) {
                  this.$swal("", response.data.message, "success");
               } else {
                  this.$swal("", response.data.message, "error");
               }
			   this.hideModal('test-modal2');
				this.fetchTest();
               this.$router.push({ name: 'test' });
            })
            .catch((error) => {
               if (error.response) {
                  if (error.response.data.message) {
                     this.errors = error.response.data.message;
                     //console.log(this.errors);
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            })
            .finally(() => (this.submit_loading = false));

			


		},


		
		testUnpublish(assigned_test){
			this.getToken();

			const config = {
			headers: {

				"Accept": "application/json",
				"Authorization": "Bearer " + this.token,
			},
			};

			let url = "lab/test/unpublish";
			let formData = new FormData();
         	formData.append("id", assigned_test.id);
			formData.append("status", 1);
			this.$axios
			.post(url, formData, config)
            .then((response) => {
               if (response.data.status) {
                  this.$swal("", response.data.message, "success");
               } else {
                  this.$swal("", response.data.message, "error");
               }
               this.$router.push({ name: 'test' });
            })
            .catch((error) => {
               if (error.response) {
                  if (error.response.data.message) {
                     this.errors = error.response.data.message;
                     //console.log(this.errors);
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            })
            .finally(() => (this.loading = false));
			this.fetchTest();
      },


	  testPublish(assigned_test){
			this.getToken();

			const config = {
			headers: {

				"Accept": "application/json",
				"Authorization": "Bearer " + this.token,
			},
			};

			let url = "lab/test/publish";
			let formData = new FormData();
         	formData.append("id", assigned_test.id);
			formData.append("status", 1);
			this.$axios
			.post(url, formData, config)
            .then((response) => {
               if (response.data.status) {
                  this.$swal("", response.data.message, "success");
               } else {
                  this.$swal("", response.data.message, "error");
               }
               this.$router.push({ name: 'test' });
            })
            .catch((error) => {
               if (error.response) {
                  if (error.response.data.message) {
                     this.errors = error.response.data.message;
                     //console.log(this.errors);
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            })
            .finally(() => (this.loading = false));
			this.fetchTest();
      },

		
		clearForm() {
			this.isEdit = false;
			this.modal_title = "Add Test";
			this.button_title = "Save";
			this.errors = {};
			 this.errors.test_ids = [];
            this.selectedTest = "";
            this.tests = [];
		},
	},
};
</script>
    